export default __webpack_public_path__ + "programming.8e5ffe69.jpeg";